import { render, staticRenderFns } from "./suscripciones.vue?vue&type=template&id=fb169560&"
import script from "./suscripciones.vue?vue&type=script&lang=js&"
export * from "./suscripciones.vue?vue&type=script&lang=js&"
import style0 from "./suscripciones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports